<app-gift-list-component class="full-width-height" [pageMode]="true" [mode]="'list'" [reset]="reset"></app-gift-list-component>